import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonWithLoading } from './ButtonWithLoading';
export const ButtonSave = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function ButtonSave(props, ref) {
  const {
    t
  } = useTranslation('common');
  return <ButtonWithLoading color="primary" variant="contained" {...props} data-testid="button-save" ref={ref}>
				{props.children || t('buttons.save')}
			</ButtonWithLoading>;
});